import { useEffect,useState } from "react";

import { useAuth } from "shared/contexts/Auth/AuthContext";

import { IVenda } from "shared/interfaces/IVenda";
import { buscarVendasPorUsuario } from "shared/services/api/vendas.api";

export function useVendas(){

  const {user,loadingAuth}=useAuth();

  const [vendas,setVendas]=useState<IVenda[]>([]);
  const [loading,setLoading]=useState(true);

  useEffect(() => {

    async function carregar(){

      if(loadingAuth) return;

      if(!user?.uid){ setVendas([]); setLoading(false);
        return;
      }
      setLoading(true);

      try{

        const data= await buscarVendasPorUsuario();

        setVendas( Array.isArray(data)? data: []);

      }catch(error){console.error("Erro ao buscar vendas:", error);
        setVendas([]);

      }finally{ setLoading(false); }
    }
    carregar();

  }, [user?.uid,loadingAuth]);

  return {
    vendas,
    loading:loading || loadingAuth,
    vazio:!loading && vendas.length === 0,
  };
}